import { render, staticRenderFns } from "./StoreYB.vue?vue&type=template&id=0b607f96"
import script from "./StoreYB.vue?vue&type=script&lang=js"
export * from "./StoreYB.vue?vue&type=script&lang=js"
import style0 from "./StoreYB.vue?vue&type=style&index=0&id=0b607f96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports